import script from "./TodasVisitasRepository.vue?vue&type=script&lang=js"
export * from "./TodasVisitasRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__